import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import type { VoiceTranscriptionResponse } from '../../../api/types';
import { transcribeVoice } from '../api/voiceApi';

export interface TranscribeVariables {
  audio: Blob;
  mimeType: string;
}

// PARA-132 (AC-E13) — ретраи выключены явно: автоматический повтор отправки
// аудио запрещён (очереди отложенной отправки у фичи нет).
export function useVoiceTranscription(): UseMutationResult<
  VoiceTranscriptionResponse,
  Error,
  TranscribeVariables
> {
  return useMutation({
    mutationFn: ({ audio, mimeType }: TranscribeVariables) => transcribeVoice(audio, mimeType),
    retry: false,
  });
}
